<template>
  <v-row>
    <v-col cols="12">
      <general-error v-if="!!generalError && !isDialogVisiable" />
      <v-data-table
          :headers="headers"
          :items="documents"
          class="elevation-1"
          :items-per-page="itemsPerPage"
          item-key="documentType"
          disable-sort-by
          hide-default-footer
          :loading="isLoading"
          :locale="systemLocale">
        <template v-slot:progress>
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.documentType="{ item }">
          {{ $t(item.documentDescription) }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.fileName="{ item }">
          {{ item.fileName }}
        </template>

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.fileId="{ item }">
          <v-row class="pr-3">
            <v-col v-if="item.canAddFileFromClient && !item.fileId">
              <!-- переделать на простую загрузку файла -->
              <typed-file-upload
                  :disabled="isLoading"
                  :value="item.fileName"
                  :document-type="item.documentType"
                  :document-group="item.documentGroup"
                  :upload-method="uploadSingleBusinessFile" />
            </v-col>
            <v-col v-if="item.fileId">
              <btn-icon-tip
                  v-if="item.canViewFile"
                  icon="get_app"
                  :tip="$t('Скачать документ')"
                  :disabled="isLoading"
                  @click="getBusinessFile(item.fileId)" />
              <btn-icon-tip
                  v-if="item.canDeleteFile"
                  icon="delete"
                  :tip="$t('Удалить документ')"
                  :disabled="isLoading"
                  @click="openConfirmDialog(item.documentType)" />
              <!-- <btn-icon-tip
                  v-if="showSendNotificationBtn(item)"
                  icon="notification_important"
                  :tip="$t('Разослать уведомление оферентам')"
                  :disabled="isLoading"
                  @click="openConfirmNotificationDialog" /> -->
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
    <v-col>
      <confirm-dialog
          v-if="confirmDialog.show"
          :dialog-prop="confirmDialog"
          @close="closeDialog('confirmDialog')" />
    </v-col>
  </v-row>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import TypedFileUpload from '@/components/reused/ui/TypedFileUpload.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'
  // import { DOCUMENT_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_DOCUMENTATION, BUSINESS_FILES, MAILING } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      GeneralError,
      TypedFileUpload,
      ConfirmDialog

    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: -1,
        confirmDialog: {
          show: false,
          text: null,
          additional: null,
          callback: null,
          warning: true
        }
      }
    },
    computed: {
      ...mapState(BUSINESS_FILES.NAMESPACE, {
        file: state => (state[BUSINESS_FILES.STATE.CURRENT_FILE] || {})
      }),
      ...mapState(LOT_DOCUMENTATION.NAMESPACE, {
        tradeProcessDocumentation: state => (state[LOT_DOCUMENTATION.STATE.TRADE_PROCESS_DOCUMENTATION] || []),
        documentationTypes: state => (state[LOT_DOCUMENTATION.STATE.TRADE_DOCUMENT_TYPES] || [])
      }),
      isDialogVisiable () {
        return this.confirmDialog.show
      },
      documents () {
        const vm = this
        const docs = vm.tradeProcessDocumentation || []

        return vm.documentationTypes
          .map(type => {
            const doc = docs.find(d => d.documentType === type.documentType)
            if (doc) {
              return {
                ...doc,
                ...type
              }
            }
            return { ...type }
          })
          .filter(item => !vm.readonly || (vm.readonly && item.fileId && item.canViewFile))
      },
      headers () {
        return [
          { text: this.$t('Документ'), align: 'start', sortable: true, value: 'documentType' },
          { text: this.$t('Наименование файла'), align: 'start', sortable: false, value: 'fileName' },
          { text: this.$t('Действия'), align: 'start', sortable: false, value: 'fileId' }
        ]
      },
      readonly () {
        return !this.isLotOwner(this.lot) &&
          !this.isAdmin
      }
      // showSendNotificationBtn () {
      //   return item => (this.isAdmin || this.isLotOwner(this.lot)) &&
      //     item.documentType === DOCUMENT_TYPES.OFFERER_NOTIFICATION
      // }
    },
    watch: {
      lot: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal.lotId) {
            this.initialize()
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_DOCUMENTATION.NAMESPACE, {
        getTradeDocumentTypesAction: LOT_DOCUMENTATION.ACTIONS.GET_TRADE_DOCUMENT_TYPES,
        getTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.GET_TRADE_PROCESS_DOCUMENTATION,
        addTradeProcessDocumentAction: LOT_DOCUMENTATION.ACTIONS.ADD_TRADE_PROCESS_DOCUMENT,
        deleteTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.DELETE_TRADE_PROCESS_DOCUMENTATION,
        clearTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION
      }),
      ...mapActions(BUSINESS_FILES.NAMESPACE, {
        uploadSingleBusinessFileAction: BUSINESS_FILES.ACTIONS.UPLOAD_SINGLE_BUSINESS_FILE,
        getLotRequestRequiredDocumentTypesAction: BUSINESS_FILES.ACTIONS.GET_LOT_REQUEST_REQUIRED_DOCUMENT_TYPES,
        attachFileToLotRequestAction: BUSINESS_FILES.ACTIONS.ATTACH_FILE_TO_LOT_REQUEST,
        clearLotRequestFilesAction: BUSINESS_FILES.ACTIONS.CLEAR_LOT_REQUEST_FILES,
        clearSingleBusinessFileAction: BUSINESS_FILES.ACTIONS.CLEAR_SINGLE_BUSINESS_FILE
      }),
      ...mapActions(MAILING.NAMESPACE, {
        sendOffererNotificationAction: MAILING.ACTIONS.SEND_OFFERER_NOTIFICATION
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearTradeProcessDocumentationAction(),
            this.clearSingleBusinessFileAction()
          ])
      },
      initialize: async function () {
        this.isLoading = true
        try {
          await Promise.all([
            this.getTradeDocumentTypesAction({
              lotType: this.lot.lotType,
              lotId: this.lot.lotId
            }),
            this.getTradeProcessDocumentationAction({
              lotId: this.lot.lotId,
              lotType: this.lot.lotType
            })
          ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      uploadSingleBusinessFile: async function (form) {
        try {
          if (this.isAdmin) {
            form.append('creatorId', this.lot.creatorId)
          }
          this.isLoading = true
          await this.uploadSingleBusinessFileAction({
            form
          })
          await this.addTradeProcessDocument({
            fileId: this.file.fileId
          })
        } finally {
          this.isLoading = false
        }
      },
      addTradeProcessDocument: async function (file) {
        try {
          this.isLoading = true
          await this.addTradeProcessDocumentAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType,
            file
          })
          this.isLoading = true
          this.getTradeProcessDocumentation()
        } finally {
          this.isLoading = false
        }
      },
      getTradeProcessDocumentation: async function () {
        this.isLoading = true
        try {
          await this.getTradeProcessDocumentationAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      deleteTradeProcessDocumentation: async function (documentType) {
        try {
          this.isLoading = true
          await this.deleteTradeProcessDocumentationAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType,
            documentType
          })

          this.getTradeProcessDocumentation()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      sendOffererNotification: async function () {
        this.isLoading = true
        try {
          await this.sendOffererNotificationAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      openConfirmDialog: function (documentType) {
        this.confirmDialog.text = this.$t('Документ будет удален. Продолжить?')
        this.confirmDialog.additional = documentType
        this.confirmDialog.callback = this.deleteTradeProcessDocumentation
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      openConfirmNotificationDialog: function () {
        this.confirmDialog.text = this.$t('Уведомление о загрузке документа будет разослано всем оферентам. Продолжить?')
        this.confirmDialog.callback = this.sendOffererNotification
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      }
    }
  }
</script>
